import * as THREE from "three";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

class Portal {
  static createPortal(callback) {
    const loader = new GLTFLoader();
    loader.load("asset/testPortal.glb", gltf => {
      let box = new THREE.Box3().setFromObject(gltf.scene);
      box.getCenter(gltf.scene.position);

      let obj = gltf.scene;

      obj.traverse(child => {
        if (child.type === "Mesh" || child.isMesh) {
          child.position.multiplyScalar(-1);

          child.layers.set(1);
          child.name = "Portal";
          child.castShadow = true;
          child.material.format = THREE.RGBAFormat;
          child.material.tarsparent = true;
          // userData
          child.userData.name = "Portal";
          child.userData.friction = 1;
          child.userData.mass = 20;
          child.userData.type = "mesh";
          child.userData.canCollide = false;
          child.userData.isKinematic = true;
          child.userData.opacity = 1;
          child.userData.width = box.max.x - box.min.x;
          child.userData.height = box.max.y - box.min.y;
          child.userData.depth = box.max.z - box.min.z;
          // [TEMP]: BVH에 합성되지 않기 위해 필요
          child.userData.canScript = true;
          // portalInfo
          child.userData.pId = "";
          child.userData.sceneId = {};

          callback(child);
        }
      });
    });
  }
}
export default Portal;
